'use client';

import React from 'react';
import {
  allJsAtom,
  homeJsAtom,
  postJsAtom,
} from 'app/blog/[domain]/_components/design-state';
import { useAtomValue } from 'jotai';
import { useFrame } from 'react-frame-component';
import type { DesignTab } from '../design-tabs';

export function IframeJsRunner({ tab }: { tab: DesignTab }) {
  const allJs = useAtomValue(allJsAtom);
  const homeJs = useAtomValue(homeJsAtom);
  const postJs = useAtomValue(postJsAtom);
  return (
    <>
      <DynamicJsRunner js={allJs} id="layout-js" />
      {['home', 'all'].includes(tab) && (
        <DynamicJsRunner js={homeJs} id="home-js" />
      )}
      {tab === 'post' && <DynamicJsRunner js={postJs} id="post-js" />}
    </>
  );
}

export function DynamicJsRunner({ js, id }: { js: string; id: string }) {
  const { document: iframeDoc } = useFrame();
  React.useEffect(() => {
    if (!iframeDoc) {
      return;
    }
    // We need to re-insert the script to make it work for editing
    // next/script or normal script tags won't work
    const existingScript = iframeDoc.getElementById(id);
    if (existingScript) {
      existingScript.remove();
    }
    const script = iframeDoc.createElement('script');
    script.id = id;
    script.text = js;
    iframeDoc.body.appendChild(script);
  }, [js, id, iframeDoc]);
  return <></>;
}
